import { render, staticRenderFns } from "./LayoutVertical.vue?vue&type=template&id=4700ec80&scoped=true&"
import script from "./LayoutVertical.vue?vue&type=script&lang=js&"
export * from "./LayoutVertical.vue?vue&type=script&lang=js&"
import style0 from "./LayoutVertical.vue?vue&type=style&index=0&id=4700ec80&prod&lang=scss&"
import style1 from "./LayoutVertical.vue?vue&type=style&index=1&id=4700ec80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4700ec80",
  null
  
)

export default component.exports